import { useNavigate, useLocation, Link } from "react-router-dom";
import { useFormik } from "formik";
import { Button } from "reactstrap";
import { toast } from "react-toastify";
import Select from "react-select";
import axiosInstance from "../../../axiosInterceptor";
import { SwitchToggle } from "../../../helper/ImageFormat";
import { HomeSectionSchema } from "../../../Schema/Schema";



const menuTypeOptions = [
  { label: "Collection", value: "COLLECTION" },
  { label: "Products", value: "PRODUCTS" },
  {label:"Catalogue",value:"CATALOGUE"},
  { label: "CMS", value: "CMS" },
];

const AddHomeSection = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const editingId = editData?.id;
  const initialValues = {
    position: editData?.position || editData?.nextPosition,
    title: editData?.title || "",
    type: editData?.type || "",
    bgcolor: editData?.bgcolor || "#ffffff",
    isActive: editData?.isActive ?? true,
  };
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
  } = useFormik({
    initialValues,
    validationSchema: HomeSectionSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        const res = editingId
          ? await axiosInstance.put(`/home-section/${editingId}`, values)
          : await axiosInstance.post("/home-section", values);

        toast.success(res.data.message || "Saved successfully");
        navigate("/home-section");
      } catch (error) {
        toast.error(error?.response?.data?.message || "Something went wrong");
      }
    },
  });

  return (
    <div className="content-wrapper">
      <div className="page-header mt-5 mx-4">
        <h3 className="page-title">
          {editingId ? "Update" : "Add"} Home Section
        </h3>
      </div>

      <div className="col-md-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>Sort Order</label>
                    <input
                      type="number"
                      className={`form-control form-control-sm border border-dark ${
                        touched.position && errors.position ? "is-invalid" : ""
                      }`}
                      name="position"
                      placeholder="Enter sort order"
                      value={values.position}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.position && errors.position && (
                      <small className="text-danger">{errors.position}</small>
                    )}
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>Title</label>
                    <input
                      type="text"
                      className={`form-control form-control-sm border border-dark ${
                        touched.title && errors.title ? "is-invalid" : ""
                      }`}
                      name="title"
                      placeholder="Enter title"
                      value={values.title}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.title && errors.title && (
                      <small className="text-danger">{errors.title}</small>
                    )}
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>Menu Type</label>
                    <Select
                      options={menuTypeOptions}
                      value={menuTypeOptions.find(
                        (opt) => opt.value === values.type
                      )}
                      onChange={(option) =>
                        setFieldValue("type", option ? option.value : "")
                      }
                      isClearable
                      placeholder="Select Menu Type"
                      classNames={{
                        control: () =>
                          `custom-select-control border border-dark ${
                            touched.type && errors.type ? "is-invalid" : ""
                          }`,
                      }}
                    />
                    {touched.type && errors.type && (
                      <small className="text-danger">{errors.type}</small>
                    )}
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>Background Color</label>
                    <input
                      type="color"
                      className={`form-control form-control-sm form-control-color border border-dark ${
                        touched.bgcolor && errors.bgcolor ? "is-invalid" : ""
                      }`}
                      name="bgcolor"
                      value={values.bgcolor}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.bgcolor && errors.bgcolor && (
                      <small className="text-danger">{errors.bgcolor}</small>
                    )}
                  </div>
                </div>
                <div className="col-md-12 mt-4">
                  <SwitchToggle
                    checked={values.isActive}
                    onChange={(val) => setFieldValue("isActive", val)}
                  />
                </div>
              </div>
              <div className="text-center mt-4">
                <Button type="submit" color="primary" disabled={isSubmitting}>
                  {isSubmitting
                    ? editingId
                      ? "Updating..."
                      : "Submitting..."
                    : editingId
                    ? "Update"
                    : "Add"}
                </Button>

                <Link to="/home-section">
                  <Button color="danger mx-2">Cancel</Button>
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddHomeSection;
